import { IdMarketCategory } from "../../../../market/IdMarketCategory";
import { IdModal } from "../../../../modals/IdModal";
import { createPathSelectTabInModal } from "../../../path/createPathSelectTabInModal";
export var pathSelectImprovementTabInMarketMenu = function (action, state$, deps) {
    return createPathSelectTabInModal(function () { return IdModal.Market; }, function () { return IdMarketCategory.Improvement; })(action, state$, deps);
};



//////////////////
// WEBPACK FOOTER
// ./src/features/show-me/quest-tasks/buy-improvement/paths/pathSelectImprovementTabInMarketMenu.ts
// module id = 2353
// module chunks = 3